import {
  GlanceDraft,
  Partner,
  Region,
  Role,
  SqlStudioSegment,
  StudioAppConfig,
  StudioCategory,
  SubscriptionStatus,
  UserLifeTimeFilter,
} from 'glance-datatypes';

export interface BulkChangeData {
  userLifeTimeFilter: UserLifeTimeFilter;
  renderSessionProperties?: any;
  renderSessionMode?: any;
  canSkipSummary?: boolean;
  shouldUnlock?: boolean;
  categorySubscriptionStatus?: SubscriptionStatus;
  targetForCategories?: string[];
  categoryIds: string[];
  segments: SqlStudioSegment[];
  advancedCta: boolean;
}

export enum TypeFilter {
  ALL,
  WALLPAPER,
  STORY,
  SPONSORED,
  NEWS,
  FEATURE,
  GLANCETV,
}

export enum PublishFilter {
  ALL,
  UNPUBLISHED,
  PUBLISHED,
}

export enum RegionFilter {
  ANY,
  SPECIFIC,
}

export enum SortItem {
  PRIORITY_ASC,
  PRIORITY_DESC,
  DEFAULT,
}

export interface RegionPartnerTuple {
  region: Region;
  partner: Partner;
}

export interface CategorySource {
  displayName: string;
  category: StudioCategory;
}

export interface SegmentSource {
  text: string;
  id: number;
}

export enum BeaconType {
  RENDER,
  VIDEO,
  CTA,
  PEEK,
  LIKE,
  SHARE,
  HOLD,
  APP_SUBMIT,
  INSTALL_NOW,
  INSTALL_LATER,
  INSTALL_COMPLETE,
  APP_OPEN,
  VIDEO_STARTED,
  GLANCE_STARTED,
  PRIVIEW_TAP,
  VIDEO_VIEWED,
  GLANCE_VIEWED
}

export interface PublishButtonAtributes {
  disable: boolean;
  tooltip?: string;
}

export interface GlanceDraftDetailsProps {
  studioAppConfig?: StudioAppConfig;
  glanceDraftData: GlanceDraft;
  detailed: boolean;
  pristine: boolean;
  editable?: boolean;
  disableAttribution?: boolean;
  role: Role;
  onEdit: (target: string, value: any) => any;
  onSave: (isCTASecReq?: boolean) => any;
  onOverride: () => any;
  onPublish: () => any;
  onRemove: () => any;
  onPause: () => any;
  removed: boolean;
  bubbleData: any;
  cardType: number,
  adCoefficientDisabled: boolean;
  bucketPriorityDisabled: boolean;
  ecpmDisabled: boolean;
  rankDisable: boolean;
  fCapDisable: boolean;
  rankDisplay: boolean;  
  cityStates: CityStates[];
  peekSourceList: string[];
  dspPeekSourceList: string[];
}

export interface Emoji {
  id: number;
  cdnUrl: string;
  mediaType: string;
}

export interface MappedEmojis extends Emoji {
  position: number;
}

export interface EmojiMapping {
  glanceId: string;
  emojis: MappedEmojis[];
}

export interface EmojiUploadError {
  field: string;
  message: string;
}

export interface CityStates {
  cityId: number;
  cityName: string;
  stateId: number;
  stateName: string;
  countryId: number;
  countryName: string;
  region: string;
}



// WEBPACK FOOTER //
// ./src/pages/drafts/types.ts